<template>
    <div class="full-width full-height dynamic-form q-pa-md">
      <div class="row q-pa-md q-py-sm q-col-gutter-x-lg q-col-gutter-y-xs" style="height: calc(38vh - 12px);">
        <jt-dynamic-form
          v-if="formModel"
          ref="jtDynamicForm"
          :inputs="formModel.inputs"
          :interface="formModel.nmInterface"
          :relacionamentos="formModel.relacionamentos"
          :model="contract"
          no-scroll
          form-class="jtDFModalReasonJustificationWaste"
        />
      </div>
      <div class="row full-width q-col-gutter-lg justify-center q-py-lg">
        <div class="col-12 zindex" >
          <ContractServiceRegister :key="contractServiceKey" :isAdditiveOrRenovation="isAditive || isRenovation" :updateContract="updateContract" :contract="contract" @confirm="addService($event)"></ContractServiceRegister>
        </div>
      </div>
      <div class="row full-width q-col-gutter-lg justify-center q-py-lg">
          <div v-for="(button, i) in formModel.buttons" :key="i" class="col-lg-2 col-md-3">
              <q-btn class="full-width" color="info" @click="actionButton(button)">
              <q-icon
                  v-if="button.icon"
                  :name="button.icon"
                  size="18px"
                  class="position-icon-filter"
              />
              {{ button.label }}
              </q-btn>
          </div>
      </div>
    </div>
</template>
<script>
import { Component, Vue, Watch } from 'vue-property-decorator'
import { JtCrud, JtTextInput, JtInput, JtSelect } from 'jtech-webcomps'
import { repository, messageBox } from 'jtech'
const { modal } = JtCrud
import 'leaflet/dist/leaflet.css'
import ContractServiceRegister from './ContractServiceRegister.vue'

@Component({
  components: {
    JtTextInput,
    ContractServiceRegister,
    JtInput,
    JtSelect
  },
  mixins: [modal],
  name: 'ContractRegisterPage',
  props: {
    forms: {
      type: Object,
      default: () => {
        return {}
      }
    },
    title: String,
    updateContract: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isAditive: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    isRenovation: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    contratoAditivoRenovacao: {
      type: Object,
      default: () => {
        return null
      }
    }
  }
})
class ContractRegisterPage extends Vue {
    formModel = {};
    form = [];
    contract = {};
    nmInterface = 'contract.crudSimples';
    contractServiceKey = 0;

    created () {
      this.generateForm()
    }

    mounted () {
      if (this.isUpdatingContract()) {
        this.contract = { ...this.updateContract }
      }
    }

    isUpdatingContract () {
      const hasUpdateContract = !!(this.updateContract)
      const isNotEmptyUpdateContract = Object.keys(this.updateContract).length > 0
      return hasUpdateContract && isNotEmptyUpdateContract
    }

    addService (service) {
      if (!this.contract.services) this.contract.services = []
      this.contract.services.push(service)
    }

    @Watch('contract.contractNumberCrm')
    contractNumberFormat () {
      if ((typeof this.contract.contractNumberCrm === 'number' || typeof this.contract.contractNumberCrm === 'string') && String(this.contract.contractNumberCrm).length > 9) {
        this.contract.contractNumberCrm = Number(
          String(this.contract.contractNumberCrm).slice(0, 9)
        )
        messageBox.warn(this.$gettext('CONTRACT_NUMBER_MAX_LENGTH'))
        document.getElementById('contractNumberCrm').blur()
      }
    }

    async generateFormAdditive () {
      this.nmInterface = 'contract.crudAditivo'
      this.form = await repository.resolve(this.nmInterface, this.params)
      this.formModel = this.form[0]
      this.contract = this.montarObjectoAditivoRenovacao()
      this.contractServiceKey++
      this.$forceUpdate()
    }

    async generateFormRennovation () {
      this.nmInterface = 'contract.crudRenovacao'
      this.form = await repository.resolve(this.nmInterface, this.params)
      this.formModel = this.form[0]
      this.contract = this.montarObjectoAditivoRenovacao()
      this.contract.additiveNumber = 0
      this.contract.contractRootNumber = this.contratoAditivoRenovacao.contractNumberCrm
      this.contract.contractNumberCrm = null
      this.contractServiceKey++
      this.$forceUpdate()
    }

    async generateDefaultForm () {
      this.form = await repository.resolve(this.nmInterface, this.params)
      this.formModel = this.form[0]
      if (!this.isUpdatingContract()) {
        this.contract = this.form[0].dadosForm
      }
    }

    async generateForm () {
      if (this.isAditive) {
        this.generateFormAdditive()
      } else if (this.isRenovation) {
        this.generateFormRennovation()
      } else {
        this.generateDefaultForm()
      }
    }

    montarContractItemsAditivoRenovacao (idService, serviceType) {
      const contractItemResult = []
      this.contratoAditivoRenovacao.contractServices.find(item => item.id === idService).contractItems.forEach(contractItem => {
        contractItemResult.push({
          id: contractItem.id,
          minimalBilling: contractItem.minimalBilling,
          contractBidQuantity: contractItem.contractBidQuantity,
          unitPrice: contractItem.contractItemBillings && contractItem.contractItemBillings.length == 1 ? contractItem.contractItemBillings[0].value : null,
          invertedWeighing: contractItem.invertedWeighing,
          serviceType: serviceType,
          updated: false,
          carrier: contractItem.carrier_id,
          destination: contractItem.destination_id,
          landfill: contractItem.landfill_integrationCode,
          readjustmentIndex: contractItem.readjustmentIndex_id,
          residueType: contractItem.residueTypeCode,
          unitMeasureType: contractItem.unitMeasureTypeCode,
          product: contractItem.product_code,
          quantityUpTo: contractItem.quantityUpTo,
          excessValue: contractItem.excessValue,
          residueTypeText: contractItem.residueType,
          landfillText: contractItem.landfill,
          unitMeasureTypeText: contractItem.unitMeasureType,
          productText: contractItem.product,
          useEnvironmentalWeightForBilling: contractItem.useEnvironmentalWeightForBilling,
          readjustmentIndexText: contractItem.readjustmentIndex,
          contractBillingType: contractItem.contractBillingType,
          contractItemBilling: this.montarItemBillings(contractItem.contractItemBillings)
        })
      })
      return contractItemResult
    }

    montarItemBillings (contractItemBillings) {
      const result = []
      if (contractItemBillings) {
        contractItemBillings.forEach(contracItemBilling => {
          result.push({
            quantity: contracItemBilling.quantity,
            value: contracItemBilling.value,
            contractItemBillingType: contracItemBilling.contractItemBillingType
          })
        })
      }
      return result
    }

    montarServicosAditivoRenovacao () {
      const servicesResult = []
      if (this.contratoAditivoRenovacao && this.contratoAditivoRenovacao.contractServices) {
        this.contratoAditivoRenovacao.contractServices.forEach(service => {
          servicesResult.push({
            id: service.id,
            serviceType: service.serviceType,
            contractType: service.contractType,
            billingMeasurementType: service.billingMeasurementType,
            measurementStart: service.measurementStart,
            serviceTypeText: service.serviceType_nmDescricao,
            contractTypeText: service.contractTypeNmDescricao,
            billingMeasurementTypeText: service.billingMeasurementType_nmDescricao,
            priority: service.priority,
            provisionOfService: service.provisionOfService,
            minimumBillingType: service.minimumBillingType,
            contractItems: this.montarContractItemsAditivoRenovacao(service.id, service.serviceType)
          })
        })
      }
      return servicesResult
    }

    montarObjectoAditivoRenovacao () {
      return {
        id: this.contratoAditivoRenovacao.id,
        blockIfOverdue: this.contratoAditivoRenovacao.blockIfOverdue,
        additiveNumber: this.contratoAditivoRenovacao.additiveNumber++,
        contractNumberCrm: this.contratoAditivoRenovacao.contractNumberCrm,
        contractRootNumber: null,
        contractStart: this.contratoAditivoRenovacao.contractStart,
        contractEnd: this.contratoAditivoRenovacao.contractEnd,
        readjustmentDate: this.contratoAditivoRenovacao.readjustmentDate,
        paymentCondition: this.contratoAditivoRenovacao.paymentConditionCode,
        paymentConditionText: this.contratoAditivoRenovacao.paymentConditionDetail,
        paymentInstrument: this.contratoAditivoRenovacao.paymentInstrumentId,
        paymentInstrumentText: this.contratoAditivoRenovacao.paymentInstrumentDetail,
        minimalBilling: this.contratoAditivoRenovacao.minimalBilling,
        services: this.montarServicosAditivoRenovacao()
      }
    }

    get elInputs () {
      return this.formModel.inputs
    }

    get inputs () {
      return this.form[0].inputs
    }

    async actionButton (button) {
      if (!this.$refs.jtDynamicForm.isValidForm()) {
        return
      }

      if (!this.contract) {
        messageBox.error(this.$gettext('INVALID_CONTRACT'))
        return
      }

      if (!this.contract.services || this.contract.services.length == 0) {
        messageBox.error(this.$gettext('CONTRACT_WITHOUT_SERVICE'))
        return
      }

      if (this.contract.services.some(service => !service.contractItems || service.contractItems.length == 0)) {
        messageBox.error(this.$gettext('SERVICE_WITHOUT_ITEM'))
        return
      }

      if (this.isAditive) {
        this.contract.additiveNumber++
        this.$emit('confirmAdditive', this.contract)
        return
      } else if (this.isRenovation) {
        this.contract.additiveNumber = 0
        this.$emit('confirmRenovation', this.contract)
        return
      }

      this.getTextFromSelect(this.contract.paymentInstrument, 'paymentInstrument')
      this.getTextFromSelect(this.contract.paymentCondition, 'paymentCondition')

      this.$emit('confirm', this.contract)
    }

    prepareInputs (inputs) {
      return inputs
    }

    getTextFromSelect (itemValue, inputName) {
      if (this.formModel.relacionamentos[inputName] != null) {
        const textEvent = this.formModel.relacionamentos[inputName].find(type => type.value == itemValue).label
        this.contract[inputName + 'Text'] = textEvent
      }
    }
}
export default ContractRegisterPage
</script>
<style lang="stylus" scoped>
.zindex{
  z-index : 1000;
}
</style>
